// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__7b1Pf","title":"Loading_title__uhn98","last":"Loading_last__F7qp0","transaction":"Loading_transaction__35-RQ"};